import { useTranslations } from '@vocab/react';
import {
  Box,
  Column,
  Columns,
  Heading,
  IconFilter,
  Inline,
  Stack,
  Text,
} from 'braid-design-system';
import type { FC, ReactElement } from 'react';

import type { FilterFns } from 'src/components/app/FilterSideBar/useFilters';

import { FilterClearButton } from '../FilterClearButton/FilterClearButton';

import translations from './.vocab';

import * as styles from './styles.css';

interface FilterDesktopProps {
  isStickyOnDesktop: boolean;
  content: ReactElement;
  shouldShowClearFilterButton: boolean;
  resetFilters: FilterFns['resetFilters'];
}

export const FilterDesktop: FC<FilterDesktopProps> = ({
  isStickyOnDesktop,
  shouldShowClearFilterButton,
  content,
  resetFilters,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Box
      className={{
        [styles.sticky]: true,
        [styles.stickyBelowTab]: isStickyOnDesktop,
        [styles.sideBarBorder]: true,
      }}
    >
      <Box className={[styles.hideOnTablet]}>
        <Box
          className={styles.filterSideBar}
          onScroll={(event: any) => {
            const target = event?.nativeEvent?.target;
            if (target) {
              const { top } = target.getBoundingClientRect();

              if (top > 0) {
                target.scrollIntoView({ behavior: 'smooth' });
              }
            }
          }}
        >
          <Box background="surface" padding="gutter" paddingTop="large">
            <Stack space="large">
              <Columns space="small">
                <Column>
                  <Heading level="3">
                    <Inline space="xsmall" alignY="center">
                      <IconFilter />
                      <Text data={{ intercomid: 'byFilters' }}>
                        {t('Filters')}
                      </Text>
                    </Inline>
                  </Heading>
                </Column>
                <Column width="content">
                  {shouldShowClearFilterButton ? (
                    <FilterClearButton
                      resetFilters={resetFilters}
                      bleed
                      showIcon
                    />
                  ) : null}
                </Column>
              </Columns>
              {content}
            </Stack>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
